import { Box, DialogActions, Divider } from '@mui/material';
import { Button } from '@act/storybook';
import { useTracking } from '@act/react-components/tracking';

interface SubmittableDialogActionsProps {
  cancelText?: string;
  submissionText?: string;
  isValid?: boolean;
  disabled?: boolean;
  ignoreIsValid?: boolean;
  handleClose: () => void;
  handleSubmission: () => void;
}

const SubmittableDialogActions = ({
  cancelText = 'Cancel',
  submissionText = 'Submit',
  disabled = false,
  isValid = true,
  ignoreIsValid = false,
  handleClose,
  handleSubmission,
}: SubmittableDialogActionsProps) => {
  const { generateTrackingProps } = useTracking();
  return (
    <Box>
      <Divider />
      <DialogActions
        sx={{
          padding: '8px 24px',
        }}
      >
        <Button
          disabled={disabled}
          onClick={handleClose}
          variant="text"
          {...generateTrackingProps('cancel-button')}
        >
          {cancelText}
        </Button>
        <Button
          onClick={handleSubmission}
          variant="contained"
          debounced
          disabled={(!isValid && !ignoreIsValid) || disabled}
          {...generateTrackingProps('submit-button')}
        >
          {submissionText}
        </Button>
      </DialogActions>
    </Box>
  );
};

export default SubmittableDialogActions;
